import { RELATIVE_URL_PREFIX } from '../constants';

export const checkAbsoluteLink = (link: string) => !!link && link.indexOf(RELATIVE_URL_PREFIX) !== -1;

export const setLink = (link: string): string => {
	const apiUrl = process.env.REACT_APP_BASE_API_URL || '';
	return checkAbsoluteLink(link) ? link.replace(RELATIVE_URL_PREFIX, apiUrl) : link;
};
